import { FunctionComponent, useEffect, useState } from 'react';
import DaysAvailable from '../../components/daysAvailable/DaysAvailable';
import MyLeaves from '../../components/myLeaves/MyLeaves';
import { Requests } from '../../components/requests/Requests';
import './HomePage.scss';
import { Row, Col } from 'antd';
import { observer } from 'mobx-react';
import { requestDetailsModalCall, historyModalCall } from '../../containers/MainWrapper/MainWrapper';
import { Absence } from '../../components/absence/Absence';
import { useLocation } from 'react-router';
import { TypePageDaysAvailable } from '../../types';
import { useCheckAccess } from '../../utils/hooks';
import { UserStore } from '../../store/User';
import { Alert } from '@iba-team/portal-react-components/dist';
import { useTranslation } from 'react-i18next';

const HomePage: FunctionComponent = observer(() => {
  const {isAllAccessesFetched: isFetchedAccesses, isAllowedAccess} = useCheckAccess('APPROVER');
  const {profile} = UserStore;
  const location = useLocation();
  const [id, setId] = useState('');
  const [historyId, setHistoryId] = useState('');
  const { t } = useTranslation();

  useEffect(() =>{
    if(location && location.pathname.includes('leaverequest')) {
      setId(location.pathname.split('/')[2]);
    } else if (location && location.pathname.includes('history')) {
      setHistoryId(location.pathname.split('/')[2]);
    }
  },[location]);

  useEffect(()=> {
    id && requestDetailsModalCall.show({id: +id});
  },[id]);

  useEffect(()=> {
    if (historyId && !Number.isNaN(+historyId)) {
      historyModalCall.show(parseInt(historyId, 10));
    }
  },[historyId]);

  const isAbsenceAvailable = (profile.whoIsOffView !== 'NONE');

  return (
    <div className={`home ${!isFetchedAccesses && 'blur_home_wrapper'}`}>
      <>
        {!profile.isAllUserRequiredDataPresent && <Alert type='warning'>{t('messagesForBanners.noData.message')}</Alert> }
        <Row className={'row-container'}>
          <Col span={12}>
            <div>
              <DaysAvailable activePage={TypePageDaysAvailable.HOME} userId={profile.id} isUserDataValid={profile.isAllUserRequiredDataPresent}/>
              <MyLeaves isUserDataValid={profile.isAllUserRequiredDataPresent} />
            </div>
          </Col>
          <Col span={12}>{isAllowedAccess && <Requests/>} {isAbsenceAvailable && <Absence/>}</Col>
        </Row>
      </>
    </div>
  );
});

export default HomePage;
